import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { 
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, 
  DropdownMenuTrigger, DropdownMenuSeparator 
} from '@/components/ui/dropdown-menu';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';
import { FileDown, FileText, Loader2 } from 'lucide-react';

const PDFExportButton = ({ childId, childName }) => {
  const { api } = useAuth();
  const [exporting, setExporting] = useState(null);

  const handleExport = async (reportType) => {
    setExporting(reportType);
    try {
      const response = await api.get(`/reports/${childId}/pdf?report_type=${reportType}`, {
        responseType: 'blob'
      });
      
      // Create download link
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Zazu_${childName}_${reportType}_report_${new Date().toISOString().split('T')[0]}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      toast.success('Report downloaded successfully!');
    } catch (error) {
      console.error('Export error:', error);
      toast.error('Failed to generate report. Please try again.');
    } finally {
      setExporting(null);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="outline" 
          size="sm" 
          className="gap-2"
          disabled={exporting !== null}
          data-testid={`export-pdf-${childId}`}
        >
          {exporting ? (
            <Loader2 className="w-4 h-4 animate-spin" />
          ) : (
            <FileDown className="w-4 h-4" />
          )}
          Export PDF
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem 
          onClick={() => handleExport('summary')}
          disabled={exporting !== null}
          data-testid="export-summary"
        >
          <FileText className="w-4 h-4 mr-2" />
          Weekly Summary
          <span className="ml-auto text-xs text-slate-400">Quick overview</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem 
          onClick={() => handleExport('full')}
          disabled={exporting !== null}
          data-testid="export-full"
        >
          <FileText className="w-4 h-4 mr-2" />
          Full Report
          <span className="ml-auto text-xs text-slate-400">With all details</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default PDFExportButton;
